import fetchDato from './fetchDato';
import { writable } from 'svelte/store';

let body = `{allWorks{
    id
    title,
    images{url},
    survey{
      subAtomicDate
      location{
        id
        coordinates{
          latitude,
          longitude
        },
        description
      }
      
    }
  }}`;


export async function getAllWorks() {
    return await fetchDato(body).then( r=> r.allWorks );
};

export const worksStore = writable([]);




